import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { MatDialog as MatDialog, MatDialogConfig as MatDialogConfig, MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { AlertDialogData, UserNotificaitons, BulkUser } from '@core/models';
import { MsalService } from '@azure/msal-angular';
import { ToastrService } from 'ngx-toastr';
import { MemberSearchService, NewuserService, SearchorganizationService, SessionSecurityService } from '@shared/services';
import { AppMessages } from '@core/constants';
import * as XLSX from 'xlsx';


@Component({
    selector: 'app-alert-dialog',
    templateUrl: './alert-dialog.component.html',
    styleUrls: ['./alert-dialog.component.scss'],
    standalone: false
})
export class AlertDialogComponent implements OnInit {
  // Shared component to display dialogs for various components
  constructor(@Inject(MAT_DIALOG_DATA) public data: AlertDialogData, private searchOrganizationService: SearchorganizationService,
    private dialog: MatDialog, private newUserService: NewuserService, private fb: UntypedFormBuilder, private sessionSecurity: SessionSecurityService,
    private memberSearchService: MemberSearchService, public dialogRef: MatDialogRef<AlertDialogComponent>, private authService: MsalService, private toastr: ToastrService) {

    dialogRef.disableClose = true;
  }

  //html content
  htmlContent: string;

  //dialog box type flags
  isPassword = false;
  isHelp = false;
  isDate = false;
  isGeneral = false;
  isBulk = false;
  isInActivate = false;
  isNotifications = false;
  isCeoApprovalWarning = false;

  isAdmin = false;

  //model for bulk user
  bulkUser: BulkUser;

  //table data and config
  notificationsList: UserNotificaitons[] = [];
  dataSource = new MatTableDataSource<UserNotificaitons>(this.notificationsList);
  notificationData: UserNotificaitons[];
  displayedColumns: string[] = ['Count', 'Type'];

  //file upload dialog
  fileToUpload: File = null;
  convertedFile: any;
  uploadedFile: any;
  isFileUploaded = false;

  //meta data collection
  selectedSiteID: string;
  organizationsData: any[] = [];
  sites: any[] = [];
  sponsorCountryCollection: any = [];
  sponsorStateCollection: any = [];
  nonMilitary: any = [1, 2, 3, 5, 6, 7, 8, 9, 10, 11, 13];
  military: any = [4];
  salvationArmy: any = [12];
  selectedCountryID: string;
  selectedStateID: string;
  isStateVisible = true;
  organizationID: any;
  siteID: any;
  submitted = false;
  displayNonMilitary = false;
  displayMilitary = false;
  displaySalvationArmy = false;

  //initialising form group
  get f() { return this.organizationFormGroup.controls; }
  organizationFormGroup = this.fb.group({
    organization: ['', Validators.required],
    site: [''],
    country: ['', Validators.required],
    state: ['', Validators.required],
  });

  ngOnInit() {

    this.bulkUser = {
      filePath: '',
      siteId: '',
      organizationId: ''
    }


    //this.organizationFormGroup.patchValue({ country:''})

    // Determine the control to open dialogs
    if (this.data.field === 'password')
      this.isPassword = true;
    else if (this.data.field === 'date')
      this.isDate = true;
    else if (this.data.field === 'help')
      this.isHelp = true;
    else if (this.data.field === 'ceoApprovalWarning')
      this.isCeoApprovalWarning = true;
    else if (this.data.field === 'register') {
      if (this.sessionSecurity.getObject('Role') === 'Admin') {
        this.isAdmin = true;
      }

      this.getCountries();
      this.isBulk = true;
    }
    else if (this.data.field === 'notifications') {
      this.loadNotifications();
      this.isNotifications = true;
    } else if (this.data.field === 'InActivate')
      this.isInActivate = true;
    else
      this.isGeneral = true;
  }


  onSubmit() {
    if (this.organizationFormGroup.controls.state && !this.organizationFormGroup.controls.state.touched) {
      this.organizationFormGroup.controls.state.markAsTouched();
    }

    if (this.organizationFormGroup.controls.organization && !this.organizationFormGroup.controls.organization.touched) {
      this.organizationFormGroup.controls.organization.markAsTouched();
    }

    if (this.organizationFormGroup.invalid) {
      return false;
    }
  }

  // Method to fetch Countries
  getCountries() {
    this.newUserService.getCountries().subscribe((countries: any[]) => {
      this.sponsorCountryCollection = countries;
      const userId = this.sessionSecurity.getObject<string>('UserId');

      this.memberSearchService.getMyInfo(userId).subscribe(me => {
        if (me.roles.indexOf('ChiefProfessionalOfficers') > -1) {
          const selectedCountry = parseInt(me.country.split('|')[0]);
          const selectedState = parseInt(me.state.split('|')[0]);
          const activeOrg = parseInt(me.activeOrganizationID.split('|')[0]);

          this.organizationFormGroup.controls.country.setValue(selectedCountry);
          this.organizationFormGroup.patchValue({ country: selectedCountry });
          this.organizationFormGroup.controls['country'].disable();
          this.selectStateById(selectedCountry);
          this.organizationFormGroup.controls.state.setValue(selectedState);
          this.organizationFormGroup.patchValue({ state: selectedState });
          this.organizationFormGroup.controls['state'].disable();
          this.newUserService.getOrganization().subscribe(
            org => {
              if (org.length) {
                this.organizationsData = org;
                this.organizationFormGroup.controls.organization.setValue(activeOrg);
                this.organizationFormGroup.patchValue({ organization: activeOrg });
                this.organizationFormGroup.controls['organization'].disable();
                this.changeOrganization(activeOrg);
              } else {
                this.toastr.info(AppMessages.orgNoneAvailable);
              }
            });
        }
      });
    })
  }

  changeSite(siteID) {
    this.selectedSiteID = siteID;
  }

  onSelectState(stateId: string) {
    this.sites = [];
    this.displaySalvationArmy = false;
    this.displayMilitary = false;
    this.displayNonMilitary = false;
    this.getOrganizationByID(stateId);
  }

  onSelectCountry(countryId: string) {
    this.selectStateById(countryId);
    this.sites = [];
    this.organizationFormGroup.patchValue({ organization: '', site: '', state: '' });
    this.displaySalvationArmy = false;
    this.displayMilitary = false;
    this.displayNonMilitary = false;
  }

  // Method to get Organization using State Id
  getOrganizationByID(selectedStateID: string) {
    this.organizationsData = null;
    this.searchOrganizationService.getOrganization(this.selectedCountryID, selectedStateID).subscribe(
      org => {
        this.organizationsData = org;
        if (this.organizationsData.length === 0) {
          this.displaySalvationArmy = false;
          this.displayMilitary = false;
          this.displayNonMilitary = false;
          this.toastr.info(AppMessages.orgNoneAvailable);
        }
      });
  }

  changeOrganization(organizationGlobalID) {
    this.selectedSiteID = null;
    this.getClubStateCountry(organizationGlobalID);
    const selectedObject = this.organizationsData.find(obj => obj.organizationGlobalID === organizationGlobalID);
    if (selectedObject && selectedObject.serviceUnitID) {
      this.displaySalvationArmy = this.salvationArmy.includes(selectedObject.serviceUnitID);
      this.displayMilitary = this.military.includes(selectedObject.serviceUnitID);
      this.displayNonMilitary = this.nonMilitary.includes(selectedObject.serviceUnitID);
    }
  }

  // Method to get Organization details based on Organization Id
  getClubStateCountry(orgGlobalID) {
    this.newUserService.getClubStateCountry(orgGlobalID).subscribe(
      org => {

        this.organizationFormGroup.controls.site.setValue(Number(this.selectedSiteID));
        this.selectStateById(org.country[0].id);
        this.organizationFormGroup.controls.country.setValue(org.country[0].id);
        this.organizationFormGroup.controls.state.setValue(org.state[0].id);
        this.sites = org.site;

        if (this.selectedSiteID === null) {
          this.organizationFormGroup.controls.site.setValue(org.site[0].id);
          this.selectedSiteID = org.site[0].id;
        }
      });
  }

  // Method to get State details using Country Id
  selectStateById(countryID) {
    this.selectedCountryID = countryID;
    const country = this.sponsorCountryCollection.filter(country => country.pkid === countryID);
    this.sponsorStateCollection = country !== null && country[0].states !== null && country[0].states.length > 0 ? country[0].states : null;
    this.isStateVisible = true;
    if (this.sponsorStateCollection === null) {
      this.isStateVisible = false;
      this.getOrganizationByID('0');
    }
  }

  updateDataTable() {
    this.dataSource = new MatTableDataSource<UserNotificaitons>(this.notificationsList);
  }

  // Method to display records for Notifications
  loadNotifications() {
    this.notificationData = this.data.value;
    this.notificationData.forEach(element => {
      if (Number(element.count) > 0) {
        const url = Number(element.notificationType) === 0 ? '/approval-queue' : Number(element.notificationType) === 1 ? '/notifications/1' : '/notifications/0';
        const data: UserNotificaitons = {
          count: element.count,
          message: element.message,
          notificationType: element.notificationType,
          url: url
        };
        this.notificationsList.push(data);
      }
    });
    this.updateDataTable();
  }

  getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }



  onChange(evt) {
    let data;
    const target: DataTransfer = <DataTransfer>(evt.target);
    const isExcelFile = !!target.files[0].name.match(/(.xls|.xlsx)/);
    if (target.files.length > 1) {
      this.toastr.error(AppMessages.onlyOneFile);
    }
    if (isExcelFile) {

      const reader: FileReader = new FileReader();
      reader.onload = (e: any) => {
        /* read workbook */
        const bstr: string = e.target.result;
        const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary', cellDates: true });

        /* grab first sheet */
        const wsname: string = wb.SheetNames[0];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];

        /* save data */
        data = XLSX.utils.sheet_to_json(ws);
        // let json = data;
        // let fields = Object.keys(json[0])
        // let replacer = function (key, value) { return value === null ? '' : value }
        // let csv = json.map(function (row) {
        //   return fields.map(function (fieldName) {
        let json = data;
        let xFields = XLSX.utils.sheet_to_json(ws, { header: 1 })[0];
        let aFields = [];
        aFields = aFields.concat(xFields);
        let fields = Object.keys(json[0])
        let replacer = function (key, value) { return value === null ? '' : value }
        let csv = json.map(function (row) {
          return aFields.map(function (fieldName) {
            if (row[fieldName] != null && typeof row[fieldName] === 'string' && row[fieldName].indexOf(',') > -1) {
              return JSON.stringify(row[fieldName], replacer);
            } else {
              if (row[fieldName] != null) {
                return row[fieldName];
              } else {
                return '';
              }
            }
          }).join(',')
        });
        csv.unshift(fields.join(',')) // add header column
        csv = csv.join('\r\n');
        let blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });

        this.getBase64(blob).then((data) => {
          this.convertedFile = data;
          this.bulkUser.filePath = this.convertedFile.toString().substring(this.convertedFile.toString().indexOf(',') + 1);
        });
      };

      reader.readAsBinaryString(target.files[0]);

    } else {
      this.toastr.error(AppMessages.onlyFileExtensions);
    }
  }

  // Method to validate the file uploaded
  handleFileInput(fileInput: any) {

    const files = fileInput.target.files;
    this.fileToUpload = files[0];
    this.uploadedFile = this.fileToUpload.name;

    if (files && files.item(0)) {

      const idxDot = this.uploadedFile.lastIndexOf('.') + 1;
      const extFile = this.uploadedFile.substr(idxDot, this.uploadedFile.length).toLowerCase();
      if (extFile === 'csv') {
        this.isFileUploaded = true;
        this.getBase64(this.fileToUpload).then(
          data => {
            this.convertedFile = data;
            this.bulkUser.filePath = this.convertedFile.toString().substring(this.convertedFile.toString().indexOf(',') + 1);
          });
      } else if (extFile === 'xls' || extFile === 'xlsx') {
        this.isFileUploaded = true;
        this.onChange(fileInput);
      } else {
        this.uploadedFile = '';
        this.isFileUploaded = false;
        this.toastr.error(AppMessages.onlyFileExtensions);
      }
    }
  }

  // Method used to display the rules to upload excel for Bulk Registration
  openDialog(field) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {
      title: 'Conversion of Excel to CSV',
      field: 'password',
      closeButtonText: 'Close',
    };

    this.htmlContent = `<ul> 
    <li>In the Excel Workbook, Switch to File tab and then click Save As.</li> 
    <li>In the Save as type box, choose to save your Excel File as CSV (Comma delimited).</li>  
    <li>Choose your destination folder and click Save.</li>
    <li style="color:blue !important">User should enter data in all the mandatory fields in template while upload.</li>
    </ul>`;

    const dialogRef = this.dialog.open(AlertDialogComponent,
      dialogConfig);
    dialogRef.componentInstance.htmlContent = this.htmlContent;

    dialogRef.afterClosed().subscribe(

    );
  }

  // Method used for deleting User Account
  Inactivate() {
    this.newUserService.deleteUserAccount()
      .subscribe(items => {

        if (items.status) {
          this.toastr.success(AppMessages.deleteAccSuccess, AppMessages.deleteAccountTitle);
          sessionStorage.clear();
          this.authService.logoutRedirect();
        }
        else {
          this.toastr.error(AppMessages.deleteAccFailure, AppMessages.deleteAccountTitle);
        }
      });
  }

  // Method used for validating Bulk User Registration
  save() {

    if (this.organizationFormGroup.value.organization === '') {
      this.toastr.error('Please select Mandatory fields');
      return;
    }

    this.bulkUser.organizationId = (this.organizationFormGroup.value.organization) ? this.organizationFormGroup.value.organization.toString() : this.organizationFormGroup.controls.organization.value;
    const site = this.organizationFormGroup.value.site;
    this.bulkUser.siteId = site ? site.toString() : '';

    this.newUserService.bulkUserRegistration(this.bulkUser).subscribe(items => {
      if (items.status) {
        this.toastr.info(AppMessages.bulkRegSuccess, AppMessages.bulkRegistrationTitle);
        this.dialogRef.close(true);
      }
      else {
        this.toastr.error(AppMessages.bulkRegFailure, AppMessages.bulkRegistrationTitle);
      }
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }

}


